var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d2mn1ftkba"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28 -318) translate(0 303)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M16.686 11.714c0-1.388 1.13-2.518 2.518-2.518s2.517 1.13 2.517 2.518c0 .4-.323.723-.723.723-.4 0-.723-.324-.723-.723 0-.59-.48-1.071-1.07-1.071-.591 0-1.072.48-1.072 1.07 0 .4-.324.724-.723.724-.4 0-.724-.324-.724-.723zm-8.02-.008c0-1.388 1.13-2.517 2.518-2.517s2.517 1.129 2.517 2.517c0 .4-.324.723-.723.723-.4 0-.723-.324-.723-.723 0-.59-.48-1.07-1.071-1.07-.59 0-1.071.48-1.071 1.07 0 .4-.324.723-.724.723-.4 0-.723-.324-.723-.723zm-.32 6.466c-.185-.442.025-.95.468-1.134.109-.045.221-.067.333-.067.34 0 .663.201.801.536.804 1.934 2.794 3.183 5.07 3.183 2.224 0 4.203-1.25 5.04-3.185.19-.44.701-.643 1.14-.453.44.191.643.702.453 1.142-1.112 2.57-3.716 4.232-6.633 4.232-2.98 0-5.6-1.67-6.673-4.254zM24.725 30H5.274C2.366 30 0 27.634 0 24.726V5.274C0 2.366 2.366 0 5.274 0h19.452C27.634 0 30 2.366 30 5.274v19.452C30 27.634 27.634 30 24.726 30zM5.274 2.482c-1.54 0-2.792 1.253-2.792 2.792v19.452c0 1.539 1.253 2.792 2.792 2.792h19.452c1.54 0 2.792-1.253 2.792-2.792V5.274c0-1.54-1.253-2.792-2.792-2.792H5.274z",
    transform: "translate(28 15)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.77c1177f4b2b866887ed695cef3c3543.svg";
export { ForwardRef as ReactComponent };